var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleCircleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1996_133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 0C11.2311 0 8.52431 0.821086 6.22202 2.35943C3.91973 3.89777 2.12532 6.08427 1.06569 8.64243C0.006066 11.2006 -0.271181 14.0155 0.269012 16.7313C0.809206 19.447 2.14258 21.9416 4.10051 23.8995C6.05845 25.8574 8.55301 27.1908 11.2687 27.731C13.9845 28.2712 16.7994 27.9939 19.3576 26.9343C21.9157 25.8747 24.1022 24.0803 25.6406 21.778C27.1789 19.4757 28 16.7689 28 14C27.996 10.2882 26.5197 6.72958 23.8951 4.10494C21.2704 1.4803 17.7118 0.0040146 14 0ZM14 18.6667C13.146 18.6675 12.3213 18.3554 11.6818 17.7893C11.3003 17.4498 10.9387 17.1197 10.7018 16.8828L7.35001 13.5882C7.14373 13.3686 7.03039 13.0778 7.0337 12.7765C7.03701 12.4753 7.15673 12.187 7.36778 11.972C7.57884 11.757 7.86487 11.632 8.166 11.6232C8.46713 11.6143 8.76002 11.7223 8.98334 11.9245L12.3433 15.225C12.5627 15.4432 12.8893 15.7395 13.2288 16.0417C13.442 16.2297 13.7164 16.3334 14.0006 16.3334C14.2848 16.3334 14.5592 16.2297 14.7723 16.0417C15.1107 15.7407 15.4373 15.4443 15.6497 15.2332L19.0167 11.9245C19.1243 11.8099 19.254 11.7183 19.3979 11.6551C19.5418 11.5919 19.697 11.5585 19.8541 11.5567C20.0113 11.555 20.1672 11.585 20.3125 11.6451C20.4577 11.7051 20.5894 11.7938 20.6995 11.906C20.8096 12.0181 20.8959 12.1514 20.9532 12.2977C21.0106 12.4441 21.0377 12.6005 21.0331 12.7576C21.0285 12.9147 20.9922 13.0693 20.9264 13.212C20.8605 13.3547 20.7665 13.4827 20.65 13.5882L17.2912 16.8887C17.0578 17.122 16.6997 17.4487 16.3193 17.7858C15.6803 18.3537 14.8549 18.6672 14 18.6667Z",
    fill: "#5DB8E2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1996_133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleCircleDown);
export default __webpack_public_path__ + "static/media/AngleCircleDown.4bf43bea0c4757445fe27233d3a9eff6.svg";
export { ForwardRef as ReactComponent };